import { useState } from "react";
export function useMultistepForm(forms) {
    const [currentStepIndex, setCurrentStepIndex] = useState(0);
    function next() {
        setCurrentStepIndex((i) => {
            if (i >= forms.length - 1)
                return i;
            return i + 1;
        });
    }
    function back() {
        setCurrentStepIndex((i) => {
            if (i <= 0)
                return i;
            return i - 1;
        });
    }
    function goTo(index) {
        setCurrentStepIndex(index);
    }
    return {
        currentStepIndex,
        form: forms[currentStepIndex],
        forms,
        isFirstStep: currentStepIndex === 0,
        isLastStep: currentStepIndex === forms.length - 1,
        goTo,
        next,
        back,
    };
}
//# sourceMappingURL=useMultistepForm.js.map